import React, { FC } from 'react';
import { css } from 'styled-components/macro';
import IconAction from './iconAction';
import { SocialMediaLink } from '../models/footer';

const styles = {
    root: css`
        text-decoration: none;
        display: inline-block;
    `,
    icon: css`
        width: 25px;
        height: 25px;
        fill: none;

        path {
            fill: ${({ theme }) => theme.colors.blue.medium};
        }
    `,
};

const iconSet = {
    vimeo: (
        <svg
            viewBox="0 0 25 25"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.icon}
        >
            <title>vimeo of the Salt Company</title>
            <path d="M23.4325 3.23475C22.8407 2.59787 21.9839 2.25862 20.8864 2.22645C17.7876 2.12667 15.596 3.77288 14.3727 7.11871C14.3085 7.29441 14.3477 7.48924 14.4749 7.6272C14.6015 7.76437 14.7915 7.81893 14.9712 7.76971C15.323 7.67309 15.6719 7.62416 16.0082 7.62416C16.4598 7.62416 17.0608 7.70706 17.36 8.10205C17.5896 8.40519 17.6209 8.85974 17.4529 9.45298C17.311 9.95348 16.5812 11.2933 15.6779 12.711C14.5774 14.4383 13.9695 15.2127 13.7942 15.2127C13.2135 15.2127 11.1153 5.92183 11.0576 5.71806C10.4558 3.58874 10.1536 2.51992 8.19658 2.51992C6.70502 2.51992 3.37822 5.23989 0.646631 7.60954C0.478624 7.75526 0.337144 7.87804 0.227599 7.97151C-0.0364365 8.19693 -0.0762558 8.58849 0.13709 8.86289L0.646124 9.51777C0.86054 9.7937 1.25164 9.85129 1.53668 9.64887L1.56467 9.62896C2.44841 9.00113 3.28326 8.40817 3.9135 8.37567C4.59837 8.34209 5.19262 9.41052 5.90109 11.9529C7.25038 16.8912 9.30037 22.7777 11.4042 22.7777C13.6028 22.7777 16.2256 20.9166 19.616 16.5107C22.6845 12.5231 24.3276 9.36041 24.4331 7.05938C24.5124 5.32144 24.1757 4.03468 23.4325 3.23475Z" />
        </svg>
    ),
    youtube: (
        <svg
            viewBox="0 0 25 25"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.icon}
        >
            <title>youtube of the Salt Company</title>
            <path d="M19.8078 3.65479H5.19218C2.32462 3.65479 0 5.9794 0 8.84696V16.1532C0 19.0208 2.32462 21.3454 5.19218 21.3454H19.8078C22.6754 21.3454 25 19.0208 25 16.1532V8.84696C25 5.9794 22.6754 3.65479 19.8078 3.65479ZM16.2964 12.8556L9.46017 16.116C9.27802 16.2029 9.06761 16.0701 9.06761 15.8683V9.1436C9.06761 8.93894 9.28355 8.80629 9.46609 8.89881L16.3023 12.3631C16.5056 12.466 16.502 12.7575 16.2964 12.8556Z" />
        </svg>
    ),
    instagram: (
        <svg
            viewBox="0 0 25 25"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.icon}
        >
            <title>instagram of the Salt Company</title>
            <path d="M17.5524 0H7.44764C3.34099 0 0 3.34099 0 7.44764V17.5524C0 21.659 3.34099 25 7.44764 25H17.5524C21.659 25 25 21.659 25 17.5524V7.44764C25 3.34099 21.659 0 17.5524 0ZM22.485 17.5524C22.485 20.2766 20.2766 22.485 17.5524 22.485H7.44764C4.72344 22.485 2.515 20.2766 2.515 17.5524V7.44764C2.515 4.72339 4.72344 2.515 7.44764 2.515H17.5524C20.2766 2.515 22.485 4.72339 22.485 7.44764V17.5524Z" />
            <path d="M12.5001 6.03418C8.93477 6.03418 6.03418 8.93477 6.03418 12.5C6.03418 16.0653 8.93477 18.9659 12.5001 18.9659C16.0654 18.9659 18.966 16.0653 18.966 12.5C18.966 8.93473 16.0654 6.03418 12.5001 6.03418ZM12.5001 16.451C10.318 16.451 8.54918 14.6821 8.54918 12.5001C8.54918 10.318 10.3181 8.54918 12.5001 8.54918C14.6821 8.54918 16.451 10.318 16.451 12.5001C16.451 14.6821 14.6821 16.451 12.5001 16.451Z" />
            <path d="M18.9781 7.63193C19.8338 7.63193 20.5274 6.93826 20.5274 6.08257C20.5274 5.22688 19.8338 4.5332 18.9781 4.5332C18.1224 4.5332 17.4287 5.22688 17.4287 6.08257C17.4287 6.93826 18.1224 7.63193 18.9781 7.63193Z" />
        </svg>
    ),
    facebook: (
        <svg
            viewBox="0 0 512 512"
            xmlns="http://www.w3.org/2000/svg"
            css={styles.icon}
        >
            <title>facebook page of the Salt Company</title>
            <path d="m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h151v-181h-60v-90h60v-61c0-49.628906 40.371094-90 90-90h91v90h-91v61h91l-15 90h-76v181h121c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm0 0" />
        </svg>
    ),
};

const SocialLink: FC<SocialMediaLink> = (props) => (
    <IconAction css={styles.root} {...props}>
        {iconSet[props.type]}
    </IconAction>
);

export default SocialLink;
